import { GET_SPOT_ORDER_BOOK,GET_SPOT_ORDER_BOOK_ERROR,GET_SPOT_ORDER_BOOK_REQUEST,UPDATE_SPOT_ORDER_BOOK_DATA,REMOVE_SPOT_ORDER_BOOK} from "../../ActionTypes/ActionTypes.js";

const initialState = {
    stOrderBookLoading: false,
    stOrderBookData: null,
    stOrderBookError: null,
    stOrderBookStatus: null,
    isModified: false,
    isFirstLoad: true,

};

const SpotTradeOrderBookReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_SPOT_ORDER_BOOK_REQUEST:
            return { ...state, stOrderBookLoading: true, stOrderBookStatus: null, stOrderBookData: null };
        case GET_SPOT_ORDER_BOOK:
            return {
                stOrderBookLoading: false, stOrderBookData: action.payload, stOrderBookError: null, stOrderBookStatus: action?.payload?.success,

                isFirstLoad: false,
            };

        case GET_SPOT_ORDER_BOOK_ERROR:
            return { stOrderBookLoading: false, stOrderBookData: null, stOrderBookError: action?.payload, stOrderBookStatus: action?.payload?.success, isFirstLoad: false, };
        case UPDATE_SPOT_ORDER_BOOK_DATA:
            return {
                ...state,
                stOrderBookData: {
                    ...state.stOrderBookData,
                    result: {
                        ...state.stOrderBookData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_SPOT_ORDER_BOOK:
            return { ...state, stOrderBookData: null, stOrderBookError: null, isModified: false, stOrderBookStatus: null, isFirstLoad: true, stOrderBookLoading: false }

        default:
            return state;
    }
};

export default SpotTradeOrderBookReducer;